import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const opanCatNav = $(".parent-arr-js");
  const catBody = $(".c-aside-sidebar__category-body");
  const catBodyHeight = $(".c-aside-sidebar__category-body").innerHeight();
  const catHead = $(
    ".c-aside-sidebar__category-head .c-aside-sidebar__category-title"
  );
  const catLabel = $(".c-aside-navigation__parent-label");
  const catLabelText = catLabel.text();
  const catHeadTitle = catHead.text();
  const initSubCatNavDesktop = (e, self) => {
    const subMenu = self.parent().next(".c-aside-navigation__submenu");

    e.preventDefault();
    self.toggleClass("opened");
    subMenu.slideToggle("slow");
  };

  const initSubCatNav2 = (e, self) => {
    e.preventDefault();
    const subMenu = self.parent().next(".c-aside-navigation__submenu");
    let subMenuH = subMenu.innerHeight();
    const catHeadHeight = $(".c-aside-sidebar__category-head").innerHeight();
    const navHeight = $(".c-aside-sidebar-nav").innerHeight();
    let title = self.parent().attr("title");
    let dataCategory = self.parent().data("category");
    let counter = self
      .parent()
      .find(".c-aside-navigation__count")
      .text();
    let backItem =
      '<li class="c-aside-navigation__item back" data-back-to="' +
      dataCategory +
      '">' +
      title +
      "</li>";

    self.toggleClass("opened");
    subMenu.toggleClass("submenu-opened");

    if (subMenu.hasClass("submenu-opened")) {
      subMenuH = subMenu.innerHeight();
    }

    if (subMenu.find(".back").length === 0) {
      subMenu.prepend(backItem);
    }

    if (self.hasClass("opened")) {
      catHead.text(title);
      catLabel.text(title + counter).attr("data-back", dataCategory);
      catLabel.addClass("back");
      catBody.innerHeight(subMenuH);

      $(".c-aside-filters").hide();
      $(".all-cat-link").hide();
    } else {
      catHead.text(catHeadTitle);
      catLabel.text(catLabelText).removeAttr("data-back", dataCategory);
      catLabel.removeClass("back");
      catBody.innerHeight(catBodyHeight);
      $(".c-aside-filters").show();
      $(".all-cat-link").show();
    }

    $(".back").on("click", function(e) {
      $("[data-category='" + dataCategory + "'] .parent-arr-js").trigger(
        "click"
      );
    });
  };

  $(window).on("load", () => {
    if (matchBreakpoint(breakpoints.lg, "max")) {
      opanCatNav.each(function() {
        let self = $(this);

        self.on("click", e => initSubCatNav2(e, self));
      });
    } else {
      opanCatNav.each(function() {
        let self = $(this);

        self.on("click", e => initSubCatNavDesktop(e, self));
      });
    }
  });
})();
